import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ThemedHomecardWrapper from '../../common/ThemedHomecardWrapper';

import styles from './HorizontalHomecardWrapper.module.scss';

class HorizontalHomecardWrapper extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    link: PropTypes.string,
    newTab: PropTypes.bool,
    onClick: PropTypes.func,
    renderContent: PropTypes.func,
    renderImage: PropTypes.func,
    selected: PropTypes.bool,
    shadowless: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    link: '',
    newTab: true,
    onClick: () => {},
    renderContent: () => {},
    renderImage: () => {},
    selected: false,
    shadowless: false
  };

  render() {
    const theme = {
      wrapper: classNames(styles['horizontal-home-card'], {
        [styles['horizontal-home-card--shadowless']]: this.props.shadowless
      })
    };

    return <ThemedHomecardWrapper {...this.props} theme={theme} />;
  }
}

export default HorizontalHomecardWrapper;
